module.exports = __webpack_public_path__ + "static/media/RightIcon.d950c219.svg";